<template>
    <div>
        <div v-if="loading" class="loading-container">
            <b-row class="justify-content-center">
                <b-col cols="12" class="text-center">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading" class="order-details-content">
            <component-header
                :title="`Order #${mainOrderObject.orderId || ''}`"
                :hasSearch="false"
                :hasCreate="false"
                :hasReload="false"
                :hasback="true"
                @back-press="backButton"
            >
                <template #heading-before-search>
                    <b-button
                        size="md"
                        class="d-block w-100 d-md-inline-block ml-md-auto update-order-btn"
                        variant="primary"
                        @click="updateOrderModal"
                        v-if="orderDetailsData.orderStatus != 'Cancelled'"
                    >
                        Update Order
                    </b-button>
                    <ValidationObserver ref="observer">
                        <b-modal
                            title="Update Order"
                            title-class="text-white"
                            id="dateRange"
                            size="md"
                            class="heading"
                            ref="update-order-modal"
                            centered
                            hide-header-close
                            hide-footer
                        >
                            <b-row class="p-3">
                                <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Status type"
                                        :key="resetKey"
                                    >
                                        <eb-select
                                            class="select-black-text"
                                            placeholder="Select Status type"
                                            label="text"
                                            type="text"
                                            v-model="selectedStatus"
                                            :selected="selectedStatus"
                                            :options="filteredStatusList"
                                        >
                                        </eb-select>
                                        <span
                                            class="validate-error validate-error-red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Delivery agent"
                                        :key="resetKey"
                                    >
                                        <eb-select
                                            placeholder="Select Delivery Agent"
                                            label="text"
                                            type="text"
                                            v-model="selectedAgent"
                                            :selected="selectedAgent"
                                            :options="statusAgentList"
                                        >
                                        </eb-select>
                                        <span
                                            class="validate-error validate-error-red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                    <h5>Update ETA :</h5>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="ETA"
                                        :key="resetKey"
                                    >
                                        <b-input
                                            class="eta-input-margin"
                                            type="date"
                                            v-model="etaDate"
                                        >
                                        </b-input>
                                        <span
                                            class="validate-error validate-error-red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <h5>Update Delivery Time :</h5>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Delivery time"
                                        :key="resetKey"
                                    >
                                        <b-input
                                            class="mb-3"
                                            type="time"
                                            placeholder="Delivery Time"
                                            v-model="etaTime"
                                        >
                                        </b-input>
                                        <span
                                            class="validate-error validate-error-red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <div class="text-center my-3">
                                <b-button
                                    @click="hideOrderUpdateModal"
                                    class="my-0 main-navigation-button w-47 mr-2"
                                    variant="danger"
                                    >Cancel
                                </b-button>
                                <b-button
                                    @click="updateOrderStatusButton"
                                    class="my-0 main-navigation-button w-47 mr-2"
                                    variant="primary"
                                    >Update
                                </b-button>
                            </div>
                        </b-modal>
                    </ValidationObserver>
                </template>
            </component-header>

            <b-row class="align-items-center justify-content-between">
                <b-col cols="12" md="8">
                    <h1 class="ml-1 mb-3 mb-md-0 table-heading">
                        Ordered Item {{ `(${this.itemsCount})` }}
                    </h1>
                </b-col>
                <b-col cols="12" md="4" class="mb-3 mb-md-0">
                    <div
                        class="d-flex flex-wrap flex-md-nowrap justify-content-start justify-content-md-end align-items-center order-meta-row"
                    >
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Processing'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Processing'
                                        ? 'processing'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus === 'Created'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Created'
                                        ? 'created'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus === 'Returned'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Returned'
                                        ? 'returned'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Cancelled'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Cancelled'
                                        ? 'cancelled'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Delivered'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Delivered'
                                        ? 'delivered'
                                        : 'pill-payment-status span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Confirmed'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Confirmed'
                                        ? 'pill-payment-status'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Dispatched'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Dispatched'
                                        ? 'dispatched'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div>
                            <span
                                class="item-type pill-alignment pill-payment-status"
                                >{{
                                    this.orderDetailsData.type | formateString
                                }}</span
                            >
                        </div>
                        <i
                            class="fa fa-calendar span-text ml-md-2 order-meta-date"
                            aria-hidden="false"
                        >
                            &nbsp;<span>
                                {{
                                    this.orderDetailsData.createdAt
                                        | formatedate
                                }}</span
                            >
                        </i>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="8">
                    <b-row>
                        <b-col>
                            <!-- <h1 class="table-heading">
                Ordered Item {{ `(${this.itemsCount})` }}
              </h1> -->
                            <b-table
                                class="order-items-table boxstyle"
                                :dark="false"
                                :hover="false"
                                :striped="false"
                                :bordered="false"
                                :small="false"
                                :fixed="false"
                                :fields="fields"
                                responsive
                                :items="itemTable"
                                thead-class="header"
                                show-empty
                                :no-border-collapse="true"
                            >
                                <template
                                    slot="cell(imageLink)"
                                    slot-scope="data"
                                >
                                    <div>
                                        <img
                                            class="order-item-image"
                                            :src="data.item.imageLink"
                                            alt="Not Available"
                                        />
                                    </div>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="pagination-wrapper-order">
                                <b-pagination
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    :total-rows="totalRows"
                                    aria-controls="my-table"
                                    prev-text="Prev"
                                    next-text="Next"
                                    @change="paginationClick"
                                    hide-goto-end-buttons
                                ></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div
                                class="boxstyle px-3 py-1 mb-2 seller-details-card"
                            >
                                <h4>Seller Details</h4>
                                <div
                                    v-if="
                                        this.orderDetailsData.provider &&
                                        this.orderDetailsData.provider
                                            .authentication
                                    "
                                    class="mt-3"
                                >
                                    <h5 class="h5-text mb-2">
                                        Seller Name :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.userName
                                            }}</span
                                        >
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Address :
                                        <span class="span-text">
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.city) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.state) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.country) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.zip) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Phone :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.phone
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Email :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.email
                                            }}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1 mb-2">
                                <b-row class="mt-2 align-items-center payment-summary-header">
                                    <b-col cols="12" lg="4" class="mb-2 mb-lg-0">
                                        <h4 class="mb-0">Payment Summary</h4>
                                    </b-col>
                                    <b-col cols="12" lg="8">
                                        <div class="payment-summary-badges">
                                        <span
                                            class="pill-payment-status pill-alignment text-center payment-summary-pill"
                                            >{{
                                                (orderPaymentStatus &&
                                                    orderPaymentStatus[0] &&
                                                    orderPaymentStatus[0]
                                                        .status) ||
                                                ""
                                            }}</span
                                        >
                                        <span
                                            class="pill-payment-status pill-paymentType pill-alignment payment-summary-pill"
                                            >{{
                                                orderDetailsData.paymentType
                                            }}</span
                                        >
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="m-0 mt-3 payment-summary-lines">
                                    <b-col class="px-0 py-0">
                                        <h4>Sub-Total</h4>
                                        <h4>Shipping</h4>
                                        <!-- <h4 v-for="(gst, count) in gstCalculation" :key="count">
                      {{ gst.type }} @ {{ gst.percent }} %
                    </h4> -->
                                        <h4>Total Taxes</h4>
                                    </b-col>
                                    <b-col class="px-0 py-0">
                                        <h4 class="align-right payment-value-text">
                                            ₹
                                            {{ subTotal }}
                                        </h4>
                                        <h4
                                            class="shipping-charge align-right payment-value-text"
                                        >
                                            ₹
                                            {{ shippingAmount }}
                                        </h4>
                                        <!-- <h4
                      class="align-right"
                      v-for="(gst, count) in gstCalculation"
                      :key="count"
                    >
                      ₹
                      {{
                        (gst && gst.taxAmount && gst.taxAmount.toFixed(2)) ||
                        "0.00"
                      }}
                    </h4> -->
                                        <h4 class="align-right payment-value-text">
                                            ₹
                                            {{ totalTaxesCount }}
                                        </h4>
                                    </b-col>
                                </b-row>
                                <hr />
                                <div>
                                    <b-row class="mt-n3">
                                        <b-col>
                                            <h3 class="totalPrice">Total</h3>
                                        </b-col>
                                        <b-col class="align-right">
                                            <h3 class="totalPrice">
                                                ₹
                                                {{ totalOrderAmount }}
                                            </h3>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1 order-activity-card">
                                <h4 class="mb-3">Order Activity</h4>

                                <div
                                    class="activity-row"
                                    v-for="(
                                        track, index
                                    ) in orderDetailsData.reportStatusHistory"
                                    :key="index"
                                >
                                    <div class="left-section">
                                        <div
                                            :class="[
                                                'circle-icon',
                                                track.label ===
                                                'Return Received'
                                                    ? 'circle-orange'
                                                    : 'circle-green',
                                            ]"
                                        >
                                            <i
                                                :class="[
                                                    'fa',
                                                    iconPicker(track.label),
                                                ]"
                                            ></i>
                                        </div>

                                        <div
                                            :class="[
                                                index ===
                                                orderDetailsData
                                                    .reportStatusHistory
                                                    .length -
                                                    1
                                                    ? 'connector-end'
                                                    : 'connector-line',
                                            ]"
                                        ></div>
                                    </div>

                                    <div class="right-section">
                                        <h5 class="activity-title mb-1">
                                            {{ track.label }}
                                        </h5>
                                        <p class="activity-message mb-0">
                                            {{ track.message }}
                                            <span class="time activity-time">{{
                                                track.time | formatedate
                                            }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="hasReturnReceived">
                        <b-col>
                            <div v-if="!showIssueForm">
                                <div class="boxstyle px-3 py-1">
                                    <h4 class="mb-3">
                                        Return Verification (Seller)
                                    </h4>

                                    <div
                                        class="status-badge d-inline-flex align-items-center mb-3"
                                    >
                                        <i
                                            class="fa fa-exclamation-circle mr-2"
                                        ></i>
                                        Returned Item Received – Pending Seller
                                        Verification
                                    </div>

                                    <div class="verification-card p-4">
                                        <div
                                            class="d-flex align-items-start mb-3"
                                        >
                                            <div class="icon-circle mr-3">
                                                <i class="fa fa-info"></i>
                                            </div>

                                            <div>
                                                <h5
                                                    class="font-weight-bold mb-2"
                                                >
                                                    Verify Returned Item
                                                </h5>
                                                <p class="mb-0">
                                                    The returned item has been
                                                    received at your warehouse.
                                                    Please inspect the item and
                                                    verify its condition. If
                                                    there are any issues with
                                                    the returned product, you
                                                    can report them to the admin
                                                    team.
                                                </p>
                                            </div>
                                        </div>

                                        <b-button
                                            class="w-100 issue-btn mt-3"
                                            @click="showIssueForm = true"
                                        >
                                            Report an Issue
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="boxstyle px-3 py-1">
                                    <h4 class="mb-3">
                                        Return Verification (Seller)
                                    </h4>

                                    <div class="status-badge mb-3">
                                        <i
                                            class="fa fa-exclamation-circle mr-2"
                                        ></i>
                                        Returned Item Received – Pending Seller
                                        Verification
                                    </div>

                                    <div class="p-3">
                                        <h5 class="font-weight-bold mb-3">
                                            Report an Issue
                                        </h5>
                                        <p class="text-muted">
                                            If the returned item is damaged,
                                            fraudulent, or does not match the
                                            original product, you may submit an
                                            issue report to the admin team.
                                        </p>

                                        <label class="font-weight-bold"
                                            >Select Issue Type</label
                                        >

                                        <b-form-select
                                            v-model="selectedIssueType"
                                            :options="issueTypes"
                                            class="mb-3"
                                        >
                                            <template #first>
                                                <option
                                                    disabled
                                                    selected
                                                    value=""
                                                >
                                                    Choose an issue type...
                                                </option>
                                            </template>
                                        </b-form-select>

                                        <label class="font-weight-bold"
                                            >Describe the Issue</label
                                        >
                                        <b-form-textarea
                                            v-model="descriptionIssue"
                                            rows="4"
                                            placeholder="Explain what was found during inspection..."
                                            class="mb-4"
                                        ></b-form-textarea>

                                        <label class="font-weight-bold"
                                            >Upload Evidence (Images or
                                            Video)</label
                                        >
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors, validate }"
                                            name="Media"
                                        >
                                            <b-form-file
                                                id="filePicker"
                                                @change="validate"
                                                v-on:change="changePhoto"
                                                :state="Boolean()"
                                                accept="image/*,video/*"
                                                placeholder="Choose a Media..."
                                                drop-placeholder="Drop Media here..."
                                                class="mb-2"
                                            ></b-form-file>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                        <div v-if="showLoader" class="mb-2">
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            ></div>
                                        </div>
                                        <span
                                            v-if="invalidFile"
                                            class="validate-error"
                                            >Invalid File format</span
                                        >

                                        <h5 class="font-weight-bold mb-3">
                                            Product Comparison (Optional)
                                        </h5>

                                        <b-row>
                                            <b-col md="6" class="mb-3">
                                                <label>Original Product</label>
                                                <div class="comparison-box">
                                                    <img
                                                        v-if="
                                                            originalProductPhoto
                                                        "
                                                        :src="
                                                            originalProductPhoto
                                                        "
                                                        alt="Original Product"
                                                        style="
                                                            max-width: 100%;
                                                            max-height: 200px;
                                                            object-fit: contain;
                                                        "
                                                    />
                                                    <i
                                                        v-else
                                                        class="fa fa-image"
                                                    ></i>
                                                </div>
                                                <b-form-file
                                                    id="originalProductFile"
                                                    v-on:change="
                                                        changeOriginalProductPhoto
                                                    "
                                                    accept="image/*"
                                                    placeholder="Choose original product photo..."
                                                    drop-placeholder="Drop photo here..."
                                                    class="mt-2"
                                                ></b-form-file>
                                                <div
                                                    v-if="originalProductLoader"
                                                    class="mt-2"
                                                >
                                                    <div
                                                        class="spinner-border text-primary spinner-border-sm"
                                                        role="status"
                                                    ></div>
                                                </div>
                                            </b-col>

                                            <b-col md="6" class="mb-3">
                                                <label>Returned Product</label>
                                                <div class="comparison-box">
                                                    <img
                                                        v-if="
                                                            returnedProductPhoto
                                                        "
                                                        :src="
                                                            returnedProductPhoto
                                                        "
                                                        alt="Returned Product"
                                                        style="
                                                            max-width: 100%;
                                                            max-height: 200px;
                                                            object-fit: contain;
                                                        "
                                                    />
                                                    <i
                                                        v-else
                                                        class="fa fa-image"
                                                    ></i>
                                                </div>
                                                <b-form-file
                                                    id="returnedProductFile"
                                                    v-on:change="
                                                        changeReturnedProductPhoto
                                                    "
                                                    accept="image/*"
                                                    placeholder="Choose returned product photo..."
                                                    drop-placeholder="Drop photo here..."
                                                    class="mt-2"
                                                ></b-form-file>
                                                <div
                                                    v-if="returnedProductLoader"
                                                    class="mt-2"
                                                >
                                                    <div
                                                        class="spinner-border text-primary spinner-border-sm"
                                                        role="status"
                                                    ></div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <div
                                            class="d-flex justify-content-end mt-4"
                                        >
                                            <b-button
                                                variant="light"
                                                class="mr-2"
                                                @click="showIssueForm = false"
                                            >
                                                Cancel
                                            </b-button>

                                            <b-button
                                                @click="reportSubmit"
                                                class="submit-btn"
                                            >
                                                Submit Report
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col md="4">
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1">
                                <h4>Customer</h4>
                                <div
                                    v-if="isAddressAdded"
                                    class="address-card-white"
                                >
                                    <h5 class="h5-text mt-3 flex-align-center">
                                        <i
                                            class="fa fa-user fa-2x"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;&nbsp;
                                        <span class="card-span-text">
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.fullName) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <hr />
                                    <h5 class="h5-text mt-3 flex-align-center">
                                        <i
                                            class="fa fa-list fa-lg"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;&nbsp;
                                        <span
                                            v-if="orderCount[0].totalCount > 1"
                                            class="card-span-text"
                                            >{{
                                                (orderCount &&
                                                    orderCount[0].totalCount) ||
                                                ""
                                            }}
                                            Orders
                                        </span>
                                        <span v-else>
                                            {{
                                                (orderCount &&
                                                    orderCount[0].totalCount) ||
                                                ""
                                            }}
                                            Order
                                        </span>
                                    </h5>
                                    <hr />
                                    <h4 class="py-1">Contact Info</h4>
                                    <h5 class="h5-text">
                                        <i
                                            class="fa fa-envelope"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;
                                        <span class="span-text word-wrap-break">
                                            {{
                                                (contactByEmail &&
                                                    contactByEmail[0] &&
                                                    contactByEmail[0].value) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text">
                                        <i
                                            class="fa fa-phone"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;
                                        <span
                                            class="span-text"
                                            style="
                                                word-wrap: break-word;
                                                line-height: 1;
                                            "
                                        >
                                            {{
                                                (contactByPhone &&
                                                    contactByPhone[0] &&
                                                    contactByPhone[0].value) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <hr />

                                    <div
                                        v-if="orderObject.isSelfPickUp == true"
                                    >
                                        <h4>Pickup Address</h4>
                                        <h5 class="h5-text">
                                            Store Name :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.name) ||
                                                    ""
                                                }}</span
                                            >
                                        </h5>
                                        <h5 class="h5-text">
                                            Pickup Address :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .City) ||
                                                    ""
                                                }}
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .State) ||
                                                    ""
                                                }}
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .Country) ||
                                                    ""
                                                }}
                                            </span>
                                        </h5>
                                        <h5 class="h5-text">
                                            Phone :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.phone) ||
                                                    ""
                                                }}</span
                                            >
                                        </h5>
                                        <hr />
                                        <h4>Order Pickup Time</h4>
                                        <span>
                                            <i
                                                class="fa fa-calendar span-text"
                                                aria-hidden="false"
                                            >
                                                &nbsp;<span>
                                                    {{
                                                        (pickupAndDeliveryTime &&
                                                            pickupAndDeliveryTime.time) ||
                                                        "" | formatedate
                                                    }}</span
                                                >
                                            </i>
                                        </span>
                                    </div>

                                    <div v-else>
                                        <h4>Delivery Address</h4>
                                        <h5>
                                            <span
                                                class="span-text"
                                                style="
                                                    line-height: 20px;
                                                    word-wrap: break-word;
                                                "
                                            >
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.fullName) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.houseNumber) ||
                                                    ""
                                                }}
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.street1) ||
                                                    ""
                                                }}
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.street2) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.city) ||
                                                    ""
                                                }}-
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.zip) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.state) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (contactByPhone &&
                                                        contactByPhone.value) ||
                                                    ""
                                                }}
                                            </span>
                                        </h5>
                                        <hr />
                                        <h4>Billing Address</h4>
                                        <span class="span-text word-wrap-break">
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.fullName) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.houseNumber) ||
                                                ""
                                            }}
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.street1) ||
                                                ""
                                            }}
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.street2) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.city) ||
                                                ""
                                            }}-
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.zip) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.state) ||
                                                ""
                                            }}<br />
                                            {{
                                                (contactByPhone &&
                                                    contactByPhone.value) ||
                                                ""
                                            }}
                                        </span>
                                        <hr />
                                        <b-row>
                                            <b-col>
                                                <h4>Order Created Date</h4>
                                                <span>
                                                    <i
                                                        class="fa fa-calendar span-text"
                                                        aria-hidden="false"
                                                    >
                                                        &nbsp;<span
                                                            class="created-time"
                                                        >
                                                            {{
                                                                this
                                                                    .orderDetailsData
                                                                    .createdAt
                                                                    | formatedate
                                                            }}</span
                                                        >
                                                    </i>
                                                </span>
                                            </b-col>
                                        </b-row>
                                        <div v-if="pickupAndDeliveryTime">
                                            <h4>Estimated Delivery Time</h4>
                                            <span>
                                                <i
                                                    class="fa fa-calendar span-text"
                                                    aria-hidden="false"
                                                >
                                                    &nbsp;<span
                                                        class="estimated-time"
                                                    >
                                                        {{
                                                            (pickupAndDeliveryTime &&
                                                                pickupAndDeliveryTime.time) ||
                                                            "" | formatedate
                                                        }}</span
                                                    >
                                                </i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <button
                        type="button"
                        class="button-invoice mt-2 btn btn-block"
                        @click="viewInvoice"
                    >
                        VIEW INVOICE
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import currentUserData from "@/mixins/currentUser";
import { AtomSpinner } from "epic-spinners";
import cInput from "@/components/Common/CustomInput";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
export default {
    name: "OrderDetails",
    mixins: [currentUserData],
    components: {
        "component-header": ComponentHeader,
        ebButton,
        AtomSpinner,
        ebSelect,
        cInput,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            showIssueForm: false,
            issueTypes: [
                { value: "damaged_product", text: "Damaged Product" },
                { value: "wrong_item", text: "Wrong Item Returned" },
                { value: "missing_parts", text: "Missing Parts" },
            ],
            selectedIssueType: null,
            itemsCount: 0,
            detailsData: [],
            orderObject: {},
            currentPage: 1,
            loading: false,
            perPage: 5,
            totalRows: 0,
            selectedStatus: "",
            selectedAgent: "",
            referenceValue: "",
            etaDate: "",
            etaTime: "",
            pickUpTime: "",
            selectedDeliveryAgent: "",
            resetKey: 0,
            photo: "",
            mediatype: "",
            showLoader: false,
            invalidFile: false,
            originalProductPhoto: "",
            returnedProductPhoto: "",
            originalProductLoader: false,
            returnedProductLoader: false,
            descriptionIssue: "",
            statusList: [
                {
                    text: "Dispatched",
                    value: "Dispatched",
                },
                {
                    text: "Delivered",
                    value: "Delivered",
                },
                {
                    text: "Cancelled",
                    value: "Cancelled",
                },
                {
                    text: "Returned",
                    value: "Returned",
                },
                {
                    text: "Refund",
                    value: "Refund",
                },
            ],
        };
    },
    methods: {
        iconPicker(label) {
            switch (label) {
                case "Awaiting approval":
                    return "fa-hourglass";

                case "Approved":
                    return "fa-check-circle";

                case "Order Picked Up":
                    return "fa-truck";

                case "Out For Delivery":
                    return "fa-truck";

                case "Delivered":
                    return "fa-check";

                case "Return Requested":
                    return "fa-undo";

                case "Return Approved":
                    return "fa-check-circle";

                case "Pickup Assigned":
                    return "fa-user";

                case "Item Picked Up":
                    return "fa-archive";

                case "Return Received":
                    return "fa-undo";

                default:
                    return "fa-circle";
            }
        },
        async paginationClick(e) {
            this.currentPage = e;
        },
        updateOrderModal() {
            this.resetKey++;
            this.etaDate = "";
            this.etaTime = "";
            this.selectedStatus = "";
            this.selectedAgent = "";
            this.$refs["update-order-modal"].show();
        },
        hideOrderUpdateModal() {
            this.resetKey++;
            this.$refs["update-order-modal"].hide();
        },
        updateOrderStatus(e) {
            this.selectedStatus = e;
        },
        updateAgent(e) {
            this.selectedAgent = e;
        },
        backButton() {
            this.$router.push({ path: "/manage-order" });
        },
        updateDeliveryAgent() {
            {
                let payload = {
                    deliveryAgent: {
                        id: this.selectedDeliveryAgent?.value?._id,
                        isAttached: true,
                        name: this.selectedDeliveryAgent?.value?.name,
                        phone: this.selectedDeliveryAgent?.value?.phone,
                    },
                    orderId: this.orderDetailsData.orderId,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                };
                try {
                    this.$store.dispatch("order/setDeliveryAgent", payload);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        async updateOrderStatusButton() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            let dataObj = {
                actionCode: 20,
                conditions: {
                    orderId: this.orderDetailsData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                },
                set: {
                    orderStatus: this.selectedStatus.value,
                    deliveryAgent: this.selectedAgent.value,
                    reportStatus: this.selectedStatus.value,
                },
                push: {
                    reportStatusHistory: {
                        label: this.selectedStatus.value,
                        message: `Your order is ${this.selectedStatus.value}`,
                    },
                },
            };
            if (this.selectedStatus.value === "Returned") {
                dataObj.set["orderReturn"] = {
                    shippingRef: this.referenceValue,
                    shippingService: "",
                };
            } else if (this.selectedStatus.value === "Refund") {
                dataObj.set["orderReturn"] = {
                    refundAmt: this.referenceValue,
                };
            }
            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "Order status is Updated Successfully!",
                        type: "success",
                    });
                });
            this.$refs["update-order-modal"].hide();
            this.fetchOrderDetail();
            // this.$router.push({
            //   path: "/manage-order",
            // });
        },

        UpdatePickupTime() {
            const dataObj = {
                actionCode: 2,
                conditions: {
                    orderId: this.orderDetailsData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                },
                set: {
                    etaInMins: this.etaTime,
                    pickUpTime: this.pickUpTime,
                },
            };

            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "ETA & Pickup Time is Updated Successfully!",
                        type: "success",
                    });
                    this.ETATime = "";
                    this.pickUpTime = "";
                });
        },
        async viewInvoice() {
            let orderNumberId = this.orderDetailsData.orderId;
            let order_Id = this.orderDetailsData._id;
            await this.$store.dispatch("order/fetchInvoiceData", orderNumberId);
            if (this.$router.history.current.name === "OrderDetail") {
                this.$router.push({
                    name: "order-invoice",
                    params: {
                        id: orderNumberId,
                        orderId: this.$route.params.orderId,
                    },
                });
            } else {
                this.$router.push({
                    name: "order-invoice",
                    params: {
                        id: orderNumberId,
                        orderId: this.$route.params.orderId,
                    },
                });
            }
        },
        async uploadFile(file) {
            this.$toasted.info("Uploading...");
            this.showLoader = true;
            if (this.mediatype !== "IMAGE") {
                await this.$store
                    .dispatch("inventory/uploadVideoToStorage", file)
                    .then((res) => {
                        this.photo = res.data.fileUrl;
                        this.$toasted.success("Upload Complete");
                    })
                    .catch((error) => {
                        this.$toasted.error(
                            "File Upload failed! please try again.",
                        );
                    });
            } else {
                let dataobj = {
                    image: file,
                    key: (
                        Date.now().toString(36) +
                        Math.random().toString(36).substr(2, 5)
                    ).toLowerCase(),
                    isPublic: true,
                    replaceExisting: true,
                    basePath: "faq",
                };
                await this.$store
                    .dispatch("inventory/uploadImageToStorage", dataobj)
                    .then((res) => {
                        if (res) {
                            this.photo = res.data.fileUrl;
                            this.$toasted.success("Upload Complete");
                        }
                    })
                    .catch((error) => {
                        this.$toasted.error(
                            "Image not uploaded..please try again!",
                        );
                    });
            }
            this.showLoader = false;
        },
        changePhoto(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (file.type.match("image.*")) {
                this.mediatype = "IMAGE";
            } else if (file.type.match("video.*")) {
                this.mediatype = "VIDEO";
            } else {
                // Invalid file type - only images and videos are allowed
                this.invalidFile = true;
                e.target.value = "";
                return;
            }

            // Valid file type
            this.invalidFile = false;

            // Upload based on media type
            if (this.mediatype === "IMAGE") {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    this.uploadFile(reader.result);
                };
                reader.onerror = (err) => {
                    console.error("reader : ", err);
                };
            } else if (this.mediatype === "VIDEO") {
                if (e.target.files.length != 0) {
                    const formData = new FormData();
                    formData.append("file", file);
                    formData.append("isPublic", "true");
                    formData.append("replaceExisting", "true");
                    formData.append("basePath", "faq");
                    formData.append(
                        "key",
                        (
                            Date.now().toString(36) +
                            Math.random().toString(36).substr(2, 5)
                        ).toLowerCase(),
                    );
                    this.uploadFile(formData);
                }
            }
        },
        async uploadProductImage(file, type) {
            this.$toasted.info("Uploading...");
            if (type === "original") {
                this.originalProductLoader = true;
            } else {
                this.returnedProductLoader = true;
            }

            let dataobj = {
                image: file,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "faq",
            };

            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        if (type === "original") {
                            this.originalProductPhoto = res.data.fileUrl;
                        } else {
                            this.returnedProductPhoto = res.data.fileUrl;
                        }
                        this.$toasted.success("Upload Complete");
                    }
                })
                .catch((error) => {
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });

            if (type === "original") {
                this.originalProductLoader = false;
            } else {
                this.returnedProductLoader = false;
            }
        },
        changeOriginalProductPhoto(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!file.type.match("image.*")) {
                this.$toasted.error("Please select a valid image file");
                e.target.value = "";
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.uploadProductImage(reader.result, "original");
            };
            reader.onerror = (err) => {
                console.error("reader : ", err);
            };
        },
        changeReturnedProductPhoto(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!file.type.match("image.*")) {
                this.$toasted.error("Please select a valid image file");
                e.target.value = "";
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.uploadProductImage(reader.result, "returned");
            };
            reader.onerror = (err) => {
                console.error("reader : ", err);
            };
        },
        async reportSubmit() {
            if (!this.selectedIssueType) {
                this.$toasted.error("Please select an issue type");
                return;
            }
            if (!this.descriptionIssue || this.descriptionIssue.trim() === "") {
                this.$toasted.error("Please describe the issue");
                return;
            }
            if (!this.photo) {
                this.$toasted.error("Please upload evidence");
                return;
            }

            const evidenceType = this.mediatype === "IMAGE" ? "image" : "video";

            const payload = {
                custom: {
                    issueType:
                        this.selectedIssueType.text || this.selectedIssueType,
                    descriptionIssue: this.descriptionIssue,
                    evidence: {
                        type: evidenceType,
                        link: this.photo,
                    },
                },
            };

            if (this.originalProductPhoto || this.returnedProductPhoto) {
                payload.custom.productComparison = {};

                if (this.originalProductPhoto) {
                    payload.custom.productComparison.originalProduct = {
                        type: "image",
                        link: this.originalProductPhoto,
                    };
                }

                if (this.returnedProductPhoto) {
                    payload.custom.productComparison.returnProduct = {
                        type: "image",
                        link: this.returnedProductPhoto,
                    };
                }
            }

            this.$store
                .dispatch("order/updateShippingOrder", {
                    orderId: this.$route.params.orderId,
                    payload,
                })
                .then((res) => {
                    try {
                        this.$swal({
                            title: "Success",
                            text: "Issue report submitted successfully!",
                            type: "success",
                        });

                        this.selectedIssueType = null;
                        this.descriptionIssue = "";
                        this.photo = "";
                        this.mediatype = "";
                        this.originalProductPhoto = "";
                        this.returnedProductPhoto = "";
                        this.showIssueForm = false;

                        this.fetchOrderDetail();
                    } catch (postSuccessError) {
                        console.warn(
                            "Post-success action error:",
                            postSuccessError,
                        );
                        this.$swal({
                            title: "Success",
                            text: "Issue report submitted successfully!",
                            type: "success",
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error submitting issue report:", error);
                    const errorMessage =
                        error?.response?.data?.message ||
                        error?.message ||
                        "Failed to submit issue report. Please try again.";

                    this.$swal({
                        title: "Error",
                        text: errorMessage,
                        type: "error",
                    });
                });
        },
    },

    computed: {
        ...mapGetters({
            getOrderCount: "customerManagement/GetOrderGraph",
            getAgentList: "tenant/GetTenantSubAdminList",
            partnerAllData: "partner/GetPartnerData",
        }),
        ...mapState({
            orderDetailsData: (state) => state.order.orderDetailsData,
        }),
        uploadFileType() {
            if (this.mediatype == "IMAGE") return "image/*";
            if (this.mediatype == "VIDEO") return "video/*";
            return "image/*,video/*";
        },
        hasReturnReceived() {
            return (
                this.orderDetailsData &&
                this.orderDetailsData.reportStatusHistory &&
                this.orderDetailsData.reportStatusHistory.some(
                    (s) => s.label === "Return Received",
                )
            );
        },
        statusAgentList() {
            const data = this.getAgentList.map((e) => {
                return {
                    text: e.name.first,
                    value: e.name.first,
                };
            });
            const unique = [
                ...new Map(data.map((item) => [item.text, item])).values(),
            ];
            return unique;
        },
        filteredStatusList() {
            const currentStatus = this.orderDetailsData.orderStatus;
            if (currentStatus === "Dispatched") {
                return this.statusList.filter(
                    (status) => status.value !== "Dispatched",
                );
            }
            if (currentStatus === "Delivered") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Delivered" &&
                        status.value !== "Dispatched" &&
                        status.value !== "Cancelled",
                );
            }
            if (currentStatus === "Refund") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Dispatched" &&
                        status.value !== "Delivered" &&
                        status.value !== "Cancelled" &&
                        status.value !== "Refund",
                );
            }
            if (currentStatus === "Returned") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Dispatched" &&
                        status.value !== "Delivered" &&
                        status.value !== "Cancelled" &&
                        status.value !== "Returned",
                );
            }
            return this.statusList;
        },

        subTotal() {
            let subTotalAmont =
                this.orderDetailsData.orderAmount -
                this.orderDetailsData.deliveryCharges -
                this.getTotalTax;
            return subTotalAmont?.toFixed(2);
        },
        totalOrderAmount() {
            let totalAmount = this.orderDetailsData.orderAmount;
            return totalAmount?.toFixed(2);
        },
        shippingAmount() {
            let shippingCost = this.orderDetailsData.deliveryCharges;
            return shippingCost?.toFixed(2);
        },
        orderCount() {
            let allOrders = this.getOrderCount?.response?.filter(
                (numberOfOrders) => numberOfOrders.totalCount > 0,
            );
            return allOrders || 0;
        },
        itemTable() {
            if (this.orderDetailsData.modeOfSale === "OFFLINE") {
                if (this.orderDetailsData.items) {
                    const itemsData = this.orderDetailsData.items;
                    let itemInfo = [];
                    if (Array.isArray(itemsData) && itemsData.length > 0) {
                        itemsData.map((obj) => {
                            let arrayObj = {
                                imageLink: obj.product_summary.images.icon,
                                name: obj.string_attributes.map((e) => {
                                    if (e.attribute_name == "Name") {
                                        return e.attribute_value;
                                    }
                                }),
                                qty: obj.Quantity,
                                unitPrice: obj.Price,
                                price: obj.Price,
                            };
                            itemInfo.push(arrayObj);
                        });
                    }
                    return itemInfo;
                }
            } else if (this.orderDetailsData.items) {
                const itemsData = this.orderDetailsData.items;
                this.itemsCount = itemsData.length;
                if (this.currentPage) {
                    this.totalRows = itemsData.length;
                    return itemsData.slice(
                        (this.currentPage - 1) * this.perPage,
                        this.currentPage * this.perPage,
                    );
                }
                // return itemsData;
            } else {
                return [];
            }
        },
        fields() {
            const caption = [
                {
                    key: "imageLink",
                    label: "Image",
                },
                {
                    key: "name",
                    label: "Item",
                },
                {
                    key: "price",
                    label: "Unit Price",
                },
                {
                    key: "qty",
                    label: "No of Units",
                },
                {
                    key: "totalTaxes",
                    label: "Tax Amount",
                },

                {
                    key: "finalPrice",
                    label: "Total Price",
                },
            ];
            return caption;
        },
        getTotalTax() {
            let totalTax = 0;
            try {
                this.gstCalculation.forEach((obj) => {
                    totalTax = totalTax + obj.taxAmount;
                });
                return totalTax;
            } catch {
                return totalTax;
            }
        },
        gstCalculation() {
            if (this.isItemAdded) {
                let taxCalculate = [];
                this.orderDetailsData.items?.forEach((obj) => {
                    taxCalculate.push(...obj.taxes);
                });
                return taxCalculate;
            } else {
                return {};
            }
        },
        totalTaxesCount() {
            if (this.isItemAdded) {
                let totalTax = 0;
                this.orderDetailsData.items?.forEach((obj) => {
                    totalTax = totalTax + obj.totalTaxes;
                });
                return totalTax?.toFixed(2);
            } else {
                return {};
            }
        },
        isItemAdded() {
            if (
                this.orderDetailsData.items &&
                this.orderDetailsData.items !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
        // isOfficeAdded() {
        //   if (
        //     this.detailsData.provider.office &&
        //     this.detailsData.provider.office.address
        //   ) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // },
        isAddressAdded() {
            if (
                this.orderDetailsData.deliveryAddress &&
                this.orderDetailsData.deliveryAddress.address !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
        orderList() {
            if (this.$userRole === "Partner") {
                if (this.userCategory === "MANUFACTURER") {
                    return this.$store.getters["order/GetListOrderAllUsers"];
                } else {
                    return this.$store.getters["order/GetListOrderAllUsers"];
                }
            } else {
                return this.$store.getters["order/GetListOrderAllUsers"];
            }
        },
        pickUpAddress() {
            return this.orderDetailsData.deliveryAddress;
        },
        mainOrderObject() {
            if (this.orderDetailsData) {
                return this.orderDetailsData;
            } else {
                return {};
            }
        },
        // providerDetails() {
        //   let data = this.$store.getters["partner/GetPartnerDetailsById"];
        //   try {
        //     if (data._id) {
        //       return data;
        //     } else {
        //       return {};
        //     }
        //   } catch {
        //     return {};
        //   }
        // },
        provideAaddressDetail() {
            if (this.orderDetailsData?.provider.office) {
                return this.orderDetailsData?.provider.office?.address || "";
            }
        },
        orderPaymentStatus() {
            if (this.orderDetailsData) {
                let paymentStatus =
                    this.orderDetailsData.payments?.items?.filter(
                        (orderStatus) =>
                            Object.keys(orderStatus).includes("status") || "",
                    );
                return paymentStatus;
            }
        },
        contactByEmail() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address?.contacts?.filter(
                    (emailAddress) =>
                        emailAddress.contactType == "PRIMARY_EMAIL",
                );
            }
        },
        contactByPhone() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address?.contacts?.filter(
                    (emailAddress) =>
                        emailAddress.contactType == "PRIMARY_PHONE",
                );
            }
        },
        pickupAndDeliveryTime() {
            if (this.orderDetailsData) {
                let receiveTime =
                    this.orderDetailsData?.reportStatusHistory?.find((time) => {
                        if (Object.values(time).includes("Approved")) {
                            return time;
                        }
                    });
                return receiveTime;
            }
        },
        deliveryAaddressDetail() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address;
            }
        },
        async fetchOrderDetail() {
            this.loading = true;
            await this.$store.dispatch(
                "order/getOrderDetails",
                this.$route.params.orderId,
            );
            const payload = {
                customerId: this.orderDetailsData.customer?._id,
                fromDate: "",
                toDate: "",
            };
            this.loading = false;
        },
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch(
            "order/getOrderDetails",
            this.$route.params.orderId,
        );
        const payload = {
            customerId: this.orderDetailsData.customer?._id,
            fromDate: "",
            toDate: "",
        };
        await this.$store.dispatch("customerManagement/orderGraph", payload);
        this.loading = false;
        await this.$store.dispatch("tenant/fetchTenantSubAdminList", {
            limit: 30,
            page: 1,
        });
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
            }
        },
        formateString(value) {
            if (value) {
                return (
                    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                );
            }
        },
    },
};
</script>

<style scoped>
.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
    background-color: aliceblue !important;
}

[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 41px;
    color: white;
}
.activity-row {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 28px;
    gap: 12px;
}

.left-section {
    width: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex-shrink: 0;
}

.circle-icon {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    z-index: 2;
}

.circle-green {
    background: #e9f9ef;
    color: #1c9f4a;
}

.circle-orange {
    background: #fff3e0;
    color: #f57c00;
}

.connector-line {
    width: 3px;
    background: #d9d9d9;
    flex-grow: 1;
    margin-top: -2px;
    border-radius: 10px;
}

.connector-end {
    width: 3px;
    background: transparent;
    flex-grow: 1;
}

.right-section {
    flex: 1;
    min-width: 0;
    padding-top: 4px;
}

.activity-title {
    line-height: 1.3;
}

.activity-message {
    color: #334155;
    line-height: 1.45;
    overflow-wrap: anywhere;
}

.activity-time {
    display: block;
    margin-top: 4px;
}

.time {
    color: #777;
    font-size: 13px;
}
.status-badge {
    background: #fff4e5;
    color: #d97c25;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 14px;
    border: 1px solid #f3d2a2;
}

.verification-card {
    background: white;
    border-radius: 10px;
    border: 1px solid #e7e7e7;
}

.icon-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e7edff;
    color: #4a68ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.issue-btn {
    background: #2b2e99 !important;
    color: white !important;
    border-radius: 8px;
    padding: 10px;
    font-size: 16px;
}
.status-badge {
    background: #fff4e5;
    color: #d97c25;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 14px;
    border: 1px solid #f3d2a2;
}

.verification-card {
    background: white;
    border-radius: 10px;
    border: 1px solid #e7e7e7;
}

.icon-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e7edff;
    color: #4a68ff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.issue-btn {
    background: #2b2e99 !important;
    color: #fff !important;
    border-radius: 8px;
    padding: 10px;
}

.upload-box {
    border: 2px dashed #cfcfcf;
    border-radius: 10px;
    padding: 30px;
    text-align: center;
    background: #fafafa;
    cursor: pointer;
}

.comparison-box {
    border: 1px solid #ddd;
    height: 180px;
    border-radius: 10px;
    background: #f7f7f7;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #bbb;
}

.submit-btn {
    background: #f8a848;
    color: white;
    border-radius: 8px;
}
</style>
<style>
.footer-bottons-class {
    text-align: center;
    background: var(--primary) !important;
    margin-left: 40%;
}

.span-text {
    font-size: 14px;
    font-weight: normal;
    color: #000000;
    padding-top: 10px;
}
.order-color {
    font-size: 16px;
    color: #2726c1;
}
.h5-text {
    font-size: 14px;
    line-height: 10px;
}

.card-span-text {
    font-size: 14px;
    color: #000000;
    font-weight: normal;
    line-height: 17px;
}
.badge-danger {
    color: #fff;
    background-color: #faae5c;
}
.boxstyle {
    border-radius: 10px;
    border: 1px solid #dce2e7;
    background-color: #ffffff;
}
.align-right {
    text-align: end;
}
.bg-change {
    background-color: #00dfff;
}
.dot {
    height: 13px;
    width: 13px;
    margin: 2px 14px 0px -1px;
    background-color: #00b512;
    border-radius: 50%;
    display: inline-block;
}
.lastDot {
    height: 12px;
    width: 12px;
    margin: 0px 3px 0px 0px;
    background-color: #dbe4e1;
    border-radius: 50%;
    display: inline-block;
}
.verticalLine {
    border-left: 2px dashed rgb(35, 192, 35);
    padding: 6px 0px;
    height: auto;
    position: relative;
    left: 1%;
    margin-left: -3px;
    top: 0;
}
.deliveredLine {
    padding: 6px 8px;
}
.cancelledDot {
    height: 12px;
    width: 12px;
    margin: 2px 3px 2px 0px;
    border-radius: 50%;
    display: inline-block;
    background-color: #ff2f2f;
}
.table-heading {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-transform: capitalize;
    color: #000000;
}
.shipping-charge {
    color: #42b039;
}
.button-invoice {
    background: #ff9900;
    color: white;
    font-size: 13px;
}
.modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px !important;
    line-height: 24px;
}

.cancel-button {
    box-sizing: border-box;
    color: #403fe0;
    background: #ffffff;
    border: 1px solid #403fe0;
    border-radius: 4px;
}
.pill-alignment {
    padding-left: 18px !important;
    padding-right: 25px !important;
}
.span-text-pill {
    font-size: 14px;
    font-weight: normal;
    padding-top: 10px;
}
.not-selfpick {
    background: rgba(14, 0, 102, 0.31) !important;
    border: 1px solid #0e0066 !important;
    border-radius: 20px !important;
    color: #0e0066 !important;
}
.self-pick {
    background: rgba(221, 64, 95, 0.31);
    border: 1px solid #dd405f;
    border-radius: 20px;
    color: #dd405f;
}
.pill-paymentType {
    background: #ffe6eb !important;
    border: 1px solid #dd405f !important;
    border-radius: 20px !important;
    color: #dd405f !important;
}
.pill-payment-status {
    background: #d3d2ff;
    border: 1px solid #403fe0;
    border-radius: 20px;
    color: #403fe0;
    width: 100px;
    display: inline-block;
    padding: 6px 0;
    margin-top: 10px;
    text-align: center;
}
.processing {
    background: #d5ebdb;
    border: 1px solid #34a853;
    border-radius: 20px;
    color: #34a853;
}
.item-type {
    background: rgba(254, 123, 8, 0.31);
    border: 1px solid #fe7b08;
    border-radius: 20px;
    color: #fe7b08;
}
.created {
    background: hsla(286, 87%, 52%, 0.31);
    border: 1px solid #7c128d;
    border-radius: 20px;
    color: #911aa3;
}
.returned {
    background: rgba(8, 254, 16, 0.31);
    border: 1px solid #232708;
    border-radius: 20px;
    color: #232708;
}
.cancelled {
    background: rgb(251, 134, 134);
    border: 1px solid #87291f;
    border-radius: 20px;
    color: #87291f;
}
.delivered {
    background: rgba(179, 238, 120, 0.31);
    border: 1px solid #fe7b08;
    border-radius: 20px;
    color: #fe7b08;
}
.dispatched {
    background: hsla(286, 87%, 52%, 0.31);
    border: 1px solid #7c128d;
    border-radius: 20px;
    color: #911aa3;
}
.created-time {
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: #000000;
}
.estimated-time {
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.15px;

    color: #ed5519;
}
.totalPrice {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-transform: capitalize;
    color: #403fe0;
}
.order-status {
    color: #000000;
}

.loading-container {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.order-details-content {
    padding-bottom: 25px;
}

.order-title-text {
    font-size: 16px;
    line-height: 13px;
}

.update-order-btn {
    font-size: 14px;
    width: 100%;
    max-width: 200px;
}

.order-meta-row {
    gap: 8px;
}

.order-meta-date {
    white-space: nowrap;
}

.payment-summary-badges {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}

.payment-summary-pill {
    margin-top: 0;
    width: auto;
    min-width: 140px;
    padding: 6px 14px;
}

.payment-summary-lines h4 {
    margin-bottom: 8px;
}

.payment-summary-lines h4:last-child {
    margin-bottom: 0;
}

.payment-value-text {
    white-space: nowrap;
}

.select-black-text {
    color: black;
}

.validate-error-red {
    color: red;
}

.eta-input-margin {
    margin-bottom: 14px;
}

.order-items-table {
    margin-bottom: 0px;
    text-align: center;
}

.order-item-image {
    height: 50px;
}

.pagination-wrapper-order {
    float: right;
    padding: 20px 0px;
}

.address-card-white {
    background-color: #ffffff;
}

.flex-align-center {
    display: flex;
    align-items: center;
}

.word-wrap-break {
    word-wrap: break-word;
}

@media (max-width: 767.98px) {
    .order-title-text {
        font-size: 14px;
    }

    .update-order-btn {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        margin-top: 0.5rem;
    }

    .table-heading {
        margin-bottom: 0.75rem !important;
    }

    .order-meta-row {
        gap: 6px;
    }

    .order-meta-row .pill-payment-status {
        width: auto;
        min-width: 90px;
        margin-top: 0;
        padding: 5px 10px;
    }

    .order-meta-date {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 2px;
    }

    .order-activity-card {
        padding-left: 12px !important;
        padding-right: 12px !important;
    }

    .activity-row {
        margin-bottom: 22px;
        gap: 10px;
    }

    .left-section {
        width: 44px;
    }

    .circle-icon {
        width: 36px;
        height: 36px;
        font-size: 16px;
    }

    .activity-title {
        font-size: 18px;
        line-height: 1.35;
    }

    .activity-message {
        font-size: 16px;
    }

    .payment-summary-header {
        margin-top: 0.25rem !important;
    }

    .payment-summary-badges {
        gap: 8px;
    }

    .payment-summary-pill {
        min-width: 110px;
        padding: 5px 10px;
    }

    .payment-summary-lines {
        margin-top: 0.75rem !important;
    }

    .pagination-wrapper-order {
        float: none;
        text-align: center;
        padding: 15px 0px;
    }

    .seller-details-card .h5-text {
        line-height: 1.4;
        margin-bottom: 0.6rem !important;
    }

    .seller-details-card .span-text {
        display: block;
        padding-top: 2px;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
}

@media (min-width: 992px) {
    .payment-summary-badges {
        justify-content: flex-end;
    }
}
</style>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
